<template>
  <core-view class="flex-column" fill-height>
    <div class="center-selecao">
      <!-- Campo de Busca e Meio de Seleção -->
      <div class="pa-3 bg-search-container">
        <!-- Radio buttons para escolher com qual dado quer buscar -->
        <div class="mb-2">
          <v-radio-group
            v-model="criterioBusca"
            row
            dense
            hide-details
            class="ma-0 pa-0 radio-group-busca"
          >
            <v-radio
              v-for="opcao in opcoesBusca"
              :key="opcao.value"
              :label="opcao.label"
              :value="opcao.value"
              color="#4CAF50"
              class="radio-busca-item"
            />
          </v-radio-group>
        </div>

        <!-- Linha com Input de Busca e Botões de Ação (Início / Contém) -->
        <div class="d-flex align-center">
          <v-text-field
            v-model="pesquisa"
            outlined
            dense
            clearable
            autofocus
            :placeholder="placeholderBusca"
            hide-details="auto"
            background-color="white"
            class="campo-busca-input flex-grow-1 mr-2"
            @keydown.enter.prevent="$_onEnterBusca"
          />

          <!-- Botão: Começa com (Início) -->
          <v-btn
            depressed
            dark
            class="btn-busca-acao mr-1"
            title="Buscar por início (começa com)"
            @click="$_executarBusca('inicio')"
          >
            <v-icon size="20">mdi-arrow-left-thick</v-icon>
          </v-btn>

          <!-- Botão: Contém (Qualquer parte) -->
          <v-btn
            depressed
            dark
            class="btn-busca-acao"
            title="Buscar em qualquer parte (contém)"
            @click="$_executarBusca('contem')"
          >
            <v-icon size="18" class="mr-n1">mdi-arrow-left-thick</v-icon>
            <v-icon size="18">mdi-arrow-right-thick</v-icon>
          </v-btn>
        </div>
      </div>

      <!-- Filtro de Tipo (Apenas para Frota: Todos, Veículo [1], Maquinário [2]) -->
      <div v-if="campo === 'frota'" class="px-3 pb-3 bg-search-container">
        <v-btn-toggle
          v-model="filtroTipoVeiculo"
          mandatory
          dense
          color="primary"
          class="w-100 d-flex toggle-filtro-frota"
        >
          <v-btn value="todos" height="36" class="flex-grow-1 text-none font-weight-medium btn-filtro-frota">
            Todos
          </v-btn>
          <v-btn :value="1" height="36" class="flex-grow-1 text-none font-weight-medium btn-filtro-frota">
            Veículo
          </v-btn>
          <v-btn :value="2" height="36" class="flex-grow-1 text-none font-weight-medium btn-filtro-frota">
            Maquinário
          </v-btn>
        </v-btn-toggle>
      </div>

      <!-- Barra de Status e Ações -->
      <div class="px-4 py-2 d-flex justify-space-between align-center text-caption grey--text text--darken-2">
        <!-- <span v-if="itensFiltrados.length > 0">
          <template v-if="temMaisItens">
            Mostrando {{ itensVisiveis.length }} de {{ itensFiltrados.length }} {{ itensFiltrados.length === 1 ? 'item' : 'itens' }}
          </template>
          <template v-else>
            {{ itensFiltrados.length }} {{ itensFiltrados.length === 1 ? 'item encontrado' : 'itens encontrados' }}
          </template>
        </span>
        <span v-else>
          0 itens encontrados
        </span> -->
        <v-btn
          v-if="valorAtual"
          text
          x-small
          color="red darken-1"
          class="text-none font-weight-medium"
          @click="$_limparSelecao"
        >
          <v-icon left x-small>mdi-close-circle-outline</v-icon>
          Limpar seleção
        </v-btn>
      </div>

      <v-divider></v-divider>

      <!-- Indicador de Carregamento -->
      <div v-if="loading" class="text-center py-10">
        <v-progress-circular indeterminate color="green" size="40"></v-progress-circular>
        <div class="mt-2 text-caption grey--text">Carregando itens...</div>
      </div>

      <!-- Lista de Itens com Simplebar -->
      <simplebar
        v-else-if="itensFiltrados.length > 0"
        ref="simplebar"
        data-simplebar
        :autoHide="false"
        class="lista-selecao-scroll pa-2 flex-grow-1"
        @scroll="$_onScroll"
      >
        <v-card
          v-for="(item, idx) in itensVisiveis"
          :key="idx"
          class="mb-2 item-selecao-card"
          :class="{ 'item-selecionado': $_isItemSelecionado(item) }"
          outlined
          hover
          @click="$_selecionarItem(item)"
        >
            <div class="pa-3 d-flex align-center">

              <!-- Informações do Item para Frota / Placa -->
              <div v-if="campo === 'frota' || campo === 'placa'" class="flex-grow-1 min-w-0 pr-2 text-wrap-container">
                <div class="d-flex align-center mb-1 flex-wrap">
                  <span
                    class="font-weight-bold text-subtitle-2 mr-2"
                    :class="{ 'green--text text--darken-3': $_isItemSelecionado(item) }"
                  >
                    {{ $_formatarFrotaTitulo(item) }}
                  </span>
                  <v-chip
                    v-if="item.veitipo"
                    x-small
                    outlined
                    color="grey darken-2"
                    class="font-weight-medium mr-1"
                  >
                    {{ item.veitipo === 2 ? 'Horímetro (HH)' : 'Odômetro (KM)' }}
                  </v-chip>
                  <v-chip
                    v-if="item.veitipomaquinario"
                    x-small
                    outlined
                    color="grey darken-2"
                    class="font-weight-medium"
                  >
                    {{ item.veitipomaquinario }}
                  </v-chip>
                </div>

                <div class="text-caption grey--text text--darken-1 mt-1 d-flex flex-wrap align-center">
                  <span v-if="item.veicapacidade" class="mr-3">
                    <strong>Tanque:</strong> {{ item.veicapacidade }}L
                  </span>
                  <span v-if="item.veiidveiculo || item.id">
                    <strong>ID:</strong> {{ item.veiidveiculo || item.id }}
                  </span>
                </div>
              </div>

              <!-- Informações do Item para Operador / Motorista / Produtor / Executor -->
              <div v-else-if="campo === 'operador' || campo === 'executor' || campo === 'motorista' || campo === 'produtor'" class="flex-grow-1 min-w-0 pr-2 text-wrap-container">

                <div class="d-flex align-center mb-1 flex-wrap">
                  <span
                    class="font-weight-bold text-subtitle-2 mr-2"
                    :class="{ 'green--text text--darken-3': $_isItemSelecionado(item) }"
                  >
                    {{ item.pesnome || 'Sem nome' }}
                  </span>
                  <v-chip
                    v-if="item.pespessoafuncionario"
                    x-small
                    outlined
                    color="grey darken-2"
                    class="font-weight-medium mr-1"
                  >
                    Funcionário
                  </v-chip>
                </div>

                <div v-if="item.pesnomefantasia" class="text-body-2 grey--text text--darken-3 font-weight-medium">
                  {{ item.pesnomefantasia }}
                </div>

                <div class="text-caption grey--text text--darken-1 mt-1 d-flex flex-wrap align-center">
                  <span v-if="item.pescpf" class="mr-3">
                    <strong>CPF:</strong> {{ item.pescpf }}
                  </span>
                  <span v-if="item.pestelefone" class="mr-3">
                    <strong>Tel:</strong> {{ item.pestelefone }}
                  </span>
                  <span v-if="item.pesemail" class="mr-3">
                    <strong>Email:</strong> {{ item.pesemail }}
                  </span>
                  <span v-if="item.pesidpessoa || item.id">
                    <strong>ID:</strong> {{ item.pesidpessoa || item.id }}
                  </span>
                </div>
              </div>

              <!-- Informações do Item para Evento -->
              <div v-else-if="campo === 'evento'" class="flex-grow-1 min-w-0 pr-2 text-wrap-container">
                <div class="d-flex align-center mb-1 flex-wrap">
                  <span
                    class="font-weight-bold text-subtitle-2 mr-2"
                    :class="{ 'green--text text--darken-3': $_isItemSelecionado(item) }"
                  >
                    {{ item.evvdescricao || item.descricao || 'Sem descrição' }}
                  </span>
                  <v-chip
                    v-if="$_isEventoInativo(item)"
                    x-small
                    color="red lighten-4"
                    text-color="red darken-4"
                    class="font-weight-bold mr-1"
                  >
                    Inativo
                  </v-chip>
                </div>

                <div class="text-caption grey--text text--darken-1 mt-1 d-flex flex-wrap align-center">
                  <span v-if="item.evvideventoveiculo || item.id">
                    <strong>Código / ID:</strong> {{ item.evvideventoveiculo || item.id }}
                  </span>
                </div>
              </div>

              <!-- Informações do Item para Propriedade -->
              <div v-else-if="campo === 'propriedade'" class="flex-grow-1 min-w-0 pr-2 text-wrap-container">
                <div class="d-flex align-center mb-1 flex-wrap">
                  <span
                    class="font-weight-bold text-subtitle-2 mr-2"
                    :class="{ 'green--text text--darken-3': $_isItemSelecionado(item) }"
                  >
                    {{ item.pronome || 'Sem nome' }}
                  </span>
                </div>

                <div class="text-caption grey--text text--darken-1 mt-1 d-flex flex-wrap align-center">
                  <span v-if="item.proidpropriedade || item.id">
                    <strong>Código / ID:</strong> {{ item.proidpropriedade || item.id }}
                  </span>
                </div>
              </div>

              <!-- Informações do Item para Atividade -->
              <div v-else-if="campo === 'atividade'" class="flex-grow-1 min-w-0 pr-2 text-wrap-container">
                <div class="d-flex align-center mb-1 flex-wrap">
                  <span
                    class="font-weight-bold text-subtitle-2 mr-2"
                    :class="{ 'green--text text--darken-3': $_isItemSelecionado(item) }"
                  >
                    {{ item.veadescricao || item.atadescricao || item.descricao || 'Sem descrição' }}
                  </span>
                  <v-chip
                    v-if="$_isAtividadeInativa(item)"
                    x-small
                    color="red lighten-4"
                    text-color="red darken-4"
                    class="font-weight-bold mr-1"
                  >
                    Inativo
                  </v-chip>
                </div>

                <div class="text-caption grey--text text--darken-1 mt-1 d-flex flex-wrap align-center">
                  <span v-if="item.veaidveiculoatividade || item.id">
                    <strong>Código / ID:</strong> {{ item.veaidveiculoatividade || item.id }}
                  </span>
                </div>
              </div>

              <!-- Informações do Item para Talhão -->
              <div v-else-if="campo === 'talhao'" class="flex-grow-1 min-w-0 pr-2 text-wrap-container">
                <div class="d-flex align-center mb-1 flex-wrap">
                  <span
                    class="font-weight-bold text-subtitle-2 mr-2"
                    :class="{ 'green--text text--darken-3': $_isItemSelecionado(item) }"
                  >
                    {{ item.taldescricaoFormatada || item.taldescricao || 'Sem descrição' }}
                  </span>
                </div>

                <div class="text-caption grey--text text--darken-1 mt-1 d-flex flex-wrap align-center">
                  <span v-if="item.talcodigo" class="mr-3">
                    <strong>Código:</strong> {{ item.talcodigo }}
                  </span>
                  <span v-if="item.talidtalhao || item.id">
                    <strong>ID:</strong> {{ item.talidtalhao || item.id }}
                  </span>
                </div>
              </div>

              <!-- Informações para outros campos -->
              <div v-else class="flex-grow-1 min-w-0 pr-2 text-wrap-container">

                <div
                  class="font-weight-medium text-body-2 item-titulo"
                  :class="{ 'green--text text--darken-3 font-weight-bold': $_isItemSelecionado(item) }"
                >
                  {{ $_getItemTexto(item) }}
                </div>

                <div
                  v-if="$_getItemSubtexto(item)"
                  class="text-caption grey--text text--darken-1 item-subtitulo mt-1"
                >
                  {{ $_getItemSubtexto(item) }}
                </div>
              </div>

              <!-- Tag ou Badge para Produto -->
              <div v-if="campo === 'produto' && item.proun" class="mr-2 flex-shrink-0">
                <v-chip
                  x-small
                  outlined
                  color="green darken-2"
                  class="font-weight-bold"
                >
                  {{ item.proun }}
                </v-chip>
              </div>

              <!-- Indicador de Seleção -->
              <div class="flex-shrink-0 d-flex align-center">
                <v-icon v-if="$_isItemSelecionado(item)" color="green darken-1">
                  mdi-check-circle
                </v-icon>
                <v-icon v-else color="grey lighten-1" small>
                  mdi-chevron-right
                </v-icon>
              </div>
            </div>
          </v-card>

        <!-- Sentinela de Carregamento Automático ao Rolar -->
        <div
          v-if="temMaisItens"
          ref="sentinelaScroll"
          class="sentinela-scroll text-center py-4 d-flex align-center justify-center"
        >
          <v-progress-circular
            indeterminate
            color="green darken-1"
            size="20"
            width="2"
            class="mr-2"
          />
          <span class="text-caption grey--text text--darken-2 font-weight-medium">
            Carregando mais itens... ({{ itensFiltrados.length - itensVisiveis.length }} restantes)
          </span>
        </div>
      </simplebar>

      <!-- Estado Vazio -->
      <div v-else class="text-center py-10 px-4">
        <v-icon size="48" color="grey lighten-1">mdi-magnify-remove-outline</v-icon>
        <div class="mt-2 text-subtitle-2 grey--text text--darken-2 font-weight-medium">
          Nenhum item encontrado
        </div>
        <div class="text-caption grey--text mt-1">
          Tente buscar com outros termos
        </div>
        <v-btn
          v-if="pesquisa || (campo === 'frota' && filtroTipoVeiculo !== 'todos')"
          small
          outlined
          color="primary"
          class="mt-3 text-none"
          @click="$_limparFiltros"
        >
          Limpar filtros
        </v-btn>
      </div>
    </div>
  </core-view>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import simplebar from 'simplebar-vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'simplebar-vue/dist/simplebar.min.css';
import CoreView from '@/components/core/view/Index.vue';
import db from '@/plugins/dexie';
import { ROUTE_APONTAMENTO_EMBARQUE_CADASTRO } from '@/constants/ROUTES';
import { APONTAMENTO_EMBARQUE_STORAGE, MANUTENCAO_STORAGE, ROTA_STORAGE } from '@/constants/STORAGE';

export default {
  name: 'ViewApontamentoEmbarqueTelaSelecao',

  components: {
    CoreView,
    simplebar,
  },

  data() {
    return {
      loading: true,
      carregandoMais: false,
      pesquisa: '',
      criterioBusca: 'razao',
      modoBusca: 'contem',
      campo: '',
      filtroTipoVeiculo: 'todos',
      itens: [],
      valorAtual: null,
      limiteExibicao: 25,
      itensPorPagina: 25,
      observer: null,
      scrollElementVinculado: null,
    };
  },

  computed: {
    opcoesBusca() {
      if (this.campo === 'operador' || this.campo === 'executor' || this.campo === 'motorista' || this.campo === 'produtor') {
        return [
          { label: 'Razão / Nome', value: 'razao', placeholder: 'Buscar por Nome...' },
          { label: 'Nome Fantasia', value: 'fantasia', placeholder: 'Buscar por Nome Fantasia...' },
          { label: 'CPF / CNPJ', value: 'cpf', placeholder: 'Buscar por CPF / CNPJ...' },
          { label: 'Código', value: 'codigo', placeholder: 'Buscar por Código...' },
        ];
      }
      if (this.campo === 'frota' || this.campo === 'placa') {
        return [
          { label: 'Placa', value: 'placa', placeholder: 'Buscar por Placa...' },
          { label: 'Frota', value: 'frota', placeholder: 'Buscar por Frota...' },
          { label: 'Código', value: 'codigo', placeholder: 'Buscar por Código...' },
        ];
      }
      if (this.campo === 'propriedade') {
        return [
          { label: 'Nome', value: 'nome', placeholder: 'Buscar por Nome da Propriedade...' },
          { label: 'Código', value: 'codigo', placeholder: 'Buscar por Código...' },
        ];
      }
      if (this.campo === 'produto') {
        return [
          { label: 'Descrição', value: 'descricao', placeholder: 'Buscar por Produto...' },
          { label: 'Código', value: 'codigo', placeholder: 'Buscar por Código...' },
        ];
      }
      if (this.campo === 'talhao') {
        return [
          { label: 'Descrição', value: 'descricao', placeholder: 'Buscar por Talhão...' },
          { label: 'Código', value: 'codigo', placeholder: 'Buscar por Código...' },
        ];
      }
      return [
        { label: 'Descrição', value: 'descricao', placeholder: 'Buscar por Descrição...' },
        { label: 'Código', value: 'codigo', placeholder: 'Buscar por Código...' },
      ];
    },

    placeholderBusca() {
      const op = this.opcoesBusca.find((o) => o.value === this.criterioBusca);
      return op ? op.placeholder : 'Buscar...';
    },

    itemLabel() {
      const labels = {
        frota: 'veidescricao',
        placa: 'veidescricao',
        operador: 'pesnome',
        motorista: 'pesnome',
        produtor: 'pesnome',
        executor: 'pesnome',
        evento: 'evvdescricao',
        propriedade: 'pronome',
        atividade: 'veadescricao',
        produto: 'prodescricao',
        talhao: 'taldescricaoFormatada',
      };
      return labels[this.campo] || 'descricao';
    },

    itensFiltrados() {
      let lista = this.itens;

      if (this.campo === 'frota' && this.filtroTipoVeiculo !== 'todos') {
        const tipoAlvo = Number(this.filtroTipoVeiculo);
        lista = lista.filter((item) => {
          if (!item) return false;
          const tipoItem = Number(item.veitipo);
          if (tipoAlvo === 2) {
            return tipoItem === 2 || Boolean(item.veitipomaquinario);
          }
          if (tipoAlvo === 1) {
            return tipoItem === 1 || (!item.veitipo && !item.veitipomaquinario);
          }
          return tipoItem === tipoAlvo;
        });
      }

      if (!this.pesquisa || !this.pesquisa.trim()) {
        return lista;
      }

      const termo = this.pesquisa.trim().toLowerCase();
      const termoSemMascara = termo.replace(/[^a-zA-Z0-9]/g, '');

      return lista.filter((item) => {
        if (!item) return false;
        const valorCampo = this.$_obterValorParaBusca(item);
        if (valorCampo == null) return false;

        const valorStr = String(valorCampo).trim().toLowerCase();
        const valorSemMascara = valorStr.replace(/[^a-zA-Z0-9]/g, '');

        if (this.modoBusca === 'inicio') {
          const matchNormal = valorStr.startsWith(termo);
          const matchSemMascara = Boolean(termoSemMascara) && valorSemMascara.startsWith(termoSemMascara);
          return matchNormal || matchSemMascara;
        }

        const matchNormal = valorStr.includes(termo);
        const matchSemMascara = Boolean(termoSemMascara) && valorSemMascara.includes(termoSemMascara);
        return matchNormal || matchSemMascara;
      });
    },

    itensVisiveis() {
      return this.itensFiltrados.slice(0, this.limiteExibicao);
    },

    temMaisItens() {
      return this.itensVisiveis.length < this.itensFiltrados.length;
    },
  },

  watch: {
    pesquisa() {
      this.limiteExibicao = this.itensPorPagina;
      this.$nextTick(() => {
        const el = this.$_getScrollElement();
        if (el) {
          el.scrollTop = 0;
        }
        this.$_iniciarObserver();
      });
    },
    criterioBusca() {
      this.limiteExibicao = this.itensPorPagina;
      this.$nextTick(() => {
        const el = this.$_getScrollElement();
        if (el) {
          el.scrollTop = 0;
        }
        this.$_iniciarObserver();
      });
    },
    modoBusca() {
      this.limiteExibicao = this.itensPorPagina;
      this.$nextTick(() => {
        const el = this.$_getScrollElement();
        if (el) {
          el.scrollTop = 0;
        }
        this.$_iniciarObserver();
      });
    },
    filtroTipoVeiculo() {
      this.limiteExibicao = this.itensPorPagina;
      this.$nextTick(() => {
        const el = this.$_getScrollElement();
        if (el) {
          el.scrollTop = 0;
        }
        this.$_iniciarObserver();
      });
    },
    campo() {
      this.$_definirCriterioPadrao();
    },
  },

  methods: {
    async $_findDb() {
      this.loading = true;
      await new Promise((resolve) => {
        setTimeout(resolve, 40);
      });
      try {
        if (this.campo === 'frota' || this.campo === 'placa') {
          const veiculos = await db.veiculo.toArray();
          const veiculosAtivos = veiculos.filter((v) => !v.veideletar);
          const getVal = (val1, val2) => {
            if (val1 != null && String(val1).trim() !== '') {
              return String(val1).trim();
            }
            if (val2 != null && String(val2).trim() !== '') {
              return String(val2).trim();
            }
            return '-';
          };
          this.itens = veiculosAtivos.map((v) => {
            const frota = getVal(v.veifrota, v.frota);
            const placa = getVal(v.veiplaca, v.placa);
            const marca = getVal(v.veimarca, v.marca);
            const descricao = `${frota} - ${placa} - ${marca}`;

            return {
              ...v,
              veidescricao: descricao,
            };
          });
        } else if (this.campo === 'operador' || this.campo === 'executor' || this.campo === 'motorista' || this.campo === 'produtor') {
          const pessoas = await db.pessoa.toArray();
          const pessoasAtivas = pessoas.filter((p) => !p.pesdeletar);
          this.itens = pessoasAtivas.map((p) => ({
            ...p,
            id: p.id || p.pesidpessoa,
            pesidpessoa: p.pesidpessoa || p.id,
            pesnome: p.pesnome || 'Sem nome',
          })).sort((a, b) => (a.pesnome || '').localeCompare(b.pesnome || ''));
        } else if (this.campo === 'evento') {
          const eventos = await db.eventosveiculos.toArray();
          console.log('telaSelecao - Eventos brutos de db.eventosveiculos:', eventos);

          const isDeletado = (e) => {
            const val = String(e.evvdeletar ?? '').toUpperCase().trim();
            return val === 'S' || val === 'TRUE' || e.evvdeletar === true || e.evvdeletar === 1;
          };
          const eventosValidos = eventos.filter((e) => !isDeletado(e));
          const listaEventos = eventosValidos.length > 0 ? eventosValidos : eventos;

          this.itens = listaEventos.map((e) => {
            const nome = e.evvdescricao || e.descricao || e.nome || (e.evvideventoveiculo ? `Evento #${e.evvideventoveiculo}` : `Evento #${e.id}`);
            const id = e.id || e.evvideventoveiculo;
            return {
              ...e,
              id,
              evvideventoveiculo: e.evvideventoveiculo || id,
              descricao: nome,
              evvdescricao: nome,
            };
          }).sort((a, b) => (a.evvdescricao || '').localeCompare(b.evvdescricao || ''));
        } else if (this.campo === 'propriedade') {
          const propriedades = await db.propriedade.toArray();
          console.log('telaSelecao - Propriedades brutas de db.propriedade:', propriedades);

          const isProDeletado = (p) => {
            const val = String(p.prodeletar ?? '').toUpperCase().trim();
            return val === 'S' || val === 'TRUE' || p.prodeletar === true || p.prodeletar === 1;
          };
          const propriedadesValidas = propriedades.filter((p) => !isProDeletado(p));
          const listaPropriedades = propriedadesValidas.length > 0 ? propriedadesValidas : propriedades;

          this.itens = listaPropriedades.map((p) => {
            const nome = p.pronome || (p.proidpropriedade ? `Propriedade #${p.proidpropriedade}` : `Propriedade #${p.id}`);
            const id = p.id || p.proidpropriedade;
            return {
              ...p,
              id,
              proidpropriedade: p.proidpropriedade || id,
              pronome: nome,
            };
          }).sort((a, b) => (a.pronome || '').localeCompare(b.pronome || ''));
        } else if (this.campo === 'atividade') {
          const atividades = await db.veiculoatividade.toArray();
          console.log('telaSelecao - Atividades brutas de db.veiculoatividade:', atividades);

          const isVeaDeletado = (a) => {
            const val = String(a.veadeletar ?? '').toUpperCase().trim();
            return val === 'S' || val === 'TRUE' || a.veadeletar === true || a.veadeletar === 1;
          };
          const atividadesValidas = atividades.filter((a) => !isVeaDeletado(a));
          const listaAtividades = atividadesValidas.length > 0 ? atividadesValidas : atividades;

          this.itens = listaAtividades.map((a) => {
            const nome = a.veadescricao || a.atadescricao || a.descricao || (a.veaidveiculoatividade ? `Atividade #${a.veaidveiculoatividade}` : `Atividade #${a.id}`);
            const id = a.id || a.veaidveiculoatividade;
            return {
              ...a,
              id,
              veaidveiculoatividade: a.veaidveiculoatividade || id,
              veadescricao: nome,
              atadescricao: nome,
              descricao: nome,
            };
          }).sort((a, b) => (a.veadescricao || '').localeCompare(b.veadescricao || ''));
        } else if (this.campo === 'produto') {
          const produtos = await db.produto.toArray();
          this.itens = produtos.map((p) => ({
            ...p,
            prodescricaoOriginal: p.prodescricao || '',
            prodescricao: p.procodigo ? `${p.procodigo} - ${p.prodescricao}` : p.prodescricao,
          }));
        } else if (this.campo === 'talhao') {
          const talhoes = await db.talhao.toArray();
          this.itens = talhoes.map((t) => {
            const cod = t.talcodigo ? `${t.talcodigo} - ` : '';
            const desc = t.taldescricao || 'Talhão';
            return {
              ...t,
              id: t.talidtalhao || t.id,
              talidtalhao: t.talidtalhao || t.id,
              talcodigo: t.talcodigo || '',
              taldescricao: t.taldescricao || '',
              taldescricaoFormatada: `${cod}${desc}`,
            };
          }).sort((a, b) => (a.taldescricaoFormatada || '').localeCompare(b.taldescricaoFormatada || ''));
        }
      } catch (err) {
        console.warn('Erro ao carregar itens da base Dexie:', err);
      } finally {
        this.limiteExibicao = this.itensPorPagina;
        this.loading = false;
        this.$nextTick(() => {
          this.$_vincularScrollListener();
          this.$_iniciarObserver();
        });
      }
    },

    $_getScrollElement() {
      if (!this.$refs.simplebar) return null;
      const sb = this.$refs.simplebar;
      return (sb.SimpleBar && sb.SimpleBar.getScrollElement && sb.SimpleBar.getScrollElement())
        || sb.scrollElement
        || (sb.$el && sb.$el.querySelector('.simplebar-content-wrapper'))
        || sb.$el;
    },

    $_onScroll(event) {
      const target = (event && event.target) || this.$_getScrollElement();
      if (!target || this.carregandoMais || !this.temMaisItens) return;
      const { scrollTop, scrollHeight, clientHeight } = target;
      if (scrollTop + clientHeight >= scrollHeight - 350) {
        this.$_carregarMaisItens();
      }
    },

    $_carregarMaisItens() {
      if (this.carregandoMais || !this.temMaisItens) return;
      this.carregandoMais = true;
      this.limiteExibicao += this.itensPorPagina;
      this.$nextTick(() => {
        this.carregandoMais = false;
        this.$_iniciarObserver();
      });
    },

    $_iniciarObserver() {
      this.$_destruirObserver();
      if (!this.temMaisItens) return;

      this.$nextTick(() => {
        const el = this.$refs.sentinelaScroll;
        if (!el) return;

        const rootEl = this.$_getScrollElement();
        try {
          this.observer = new IntersectionObserver((entries) => {
            const [entry] = entries;
            if (entry && entry.isIntersecting) {
              this.$_carregarMaisItens();
            }
          }, {
            root: rootEl || null,
            rootMargin: '300px',
            threshold: 0.01,
          });

          this.observer.observe(el);
        } catch (e) {
          console.warn('IntersectionObserver não disponível:', e);
        }
      });
    },

    $_destruirObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    },

    $_vincularScrollListener() {
      this.$_desvincularScrollListener();
      const el = this.$_getScrollElement();
      if (el) {
        el.addEventListener('scroll', this.$_onScroll, { passive: true });
        this.scrollElementVinculado = el;
      }
    },

    $_desvincularScrollListener() {
      if (this.scrollElementVinculado) {
        this.scrollElementVinculado.removeEventListener('scroll', this.$_onScroll);
        this.scrollElementVinculado = null;
      }
    },

    $_selecionarItem(item) {
      sessionStorage.setItem(
        APONTAMENTO_EMBARQUE_STORAGE.itemSelecionado,
        JSON.stringify({ campo: this.campo, item }),
      );
      sessionStorage.setItem(
        MANUTENCAO_STORAGE.itemSelecionado,
        JSON.stringify({ campo: this.campo, item }),
      );
      const rotaAnterior = sessionStorage.getItem(ROTA_STORAGE.anterior) || ROUTE_APONTAMENTO_EMBARQUE_CADASTRO.name;
      this.$router.replace({ name: rotaAnterior }).catch(() => {});
    },

    $_limparSelecao() {
      sessionStorage.setItem(
        APONTAMENTO_EMBARQUE_STORAGE.itemSelecionado,
        JSON.stringify({ campo: this.campo, item: null }),
      );
      sessionStorage.setItem(
        MANUTENCAO_STORAGE.itemSelecionado,
        JSON.stringify({ campo: this.campo, item: null }),
      );
      const rotaAnterior = sessionStorage.getItem(ROTA_STORAGE.anterior) || ROUTE_APONTAMENTO_EMBARQUE_CADASTRO.name;
      this.$router.replace({ name: rotaAnterior }).catch(() => {});
    },

    $_limparFiltros() {
      this.pesquisa = '';
      this.filtroTipoVeiculo = 'todos';
      this.modoBusca = 'contem';
      this.$_definirCriterioPadrao();
    },

    $_definirCriterioPadrao() {
      if (this.campo === 'operador' || this.campo === 'executor' || this.campo === 'motorista' || this.campo === 'produtor') {
        this.criterioBusca = 'razao';
      } else if (this.campo === 'frota' || this.campo === 'placa') {
        this.criterioBusca = 'placa';
      } else if (this.campo === 'propriedade') {
        this.criterioBusca = 'nome';
      } else if (this.campo === 'produto') {
        this.criterioBusca = 'descricao';
      } else if (this.campo === 'talhao') {
        this.criterioBusca = 'descricao';
      } else {
        this.criterioBusca = 'descricao';
      }
    },

    $_obterValorParaBusca(item) {
      if (!item) return '';

      if (this.campo === 'operador' || this.campo === 'executor' || this.campo === 'motorista' || this.campo === 'produtor') {
        if (this.criterioBusca === 'codigo') {
          return item.pesidpessoa || item.id || '';
        }
        if (this.criterioBusca === 'fantasia') {
          return item.pesnomefantasia || '';
        }
        if (this.criterioBusca === 'cpf') {
          return item.pescpf || item.pescnpj || '';
        }
        return item.pesnome || '';
      }

      if (this.campo === 'frota' || this.campo === 'placa') {
        if (this.criterioBusca === 'codigo') {
          return item.veiidveiculo || item.id || '';
        }
        if (this.criterioBusca === 'placa') {
          return item.veiplaca || item.placa || '';
        }
        if (this.criterioBusca === 'frota') {
          return item.veifrota || item.frota || '';
        }
        if (this.criterioBusca === 'marca') {
          return item.veimarca || item.marca || item.veidescricao || '';
        }
        return item.veiplaca || item.placa || item.veifrota || item.frota || '';
      }

      if (this.campo === 'propriedade') {
        if (this.criterioBusca === 'codigo') {
          return item.proidpropriedade || item.id || '';
        }
        return item.pronome || item.descricao || '';
      }

      if (this.campo === 'produto') {
        if (this.criterioBusca === 'codigo') {
          return item.procodigo || item.proidproduto || item.id || '';
        }
        return item.prodescricao || item.descricao || '';
      }

      if (this.campo === 'talhao') {
        if (this.criterioBusca === 'codigo') {
          return item.talcodigo || item.talidtalhao || item.id || '';
        }
        return item.taldescricaoFormatada || item.taldescricao || '';
      }

      if (this.campo === 'evento') {
        if (this.criterioBusca === 'codigo') {
          return item.evvideventoveiculo || item.id || '';
        }
        return item.evvdescricao || item.descricao || item.nome || '';
      }

      if (this.campo === 'atividade') {
        if (this.criterioBusca === 'codigo') {
          return item.veaidveiculoatividade || item.id || item.atacodigo || '';
        }
        return item.veadescricao || item.atadescricao || item.descricao || '';
      }

      if (this.criterioBusca === 'codigo') {
        return item.id || item.codigo || '';
      }
      return item[this.itemLabel] || item.descricao || item.nome || '';
    },

    $_executarBusca(modo) {
      if (modo) {
        this.modoBusca = modo;
      }
      this.limiteExibicao = this.itensPorPagina;
      this.$nextTick(() => {
        const el = this.$_getScrollElement();
        if (el) {
          el.scrollTop = 0;
        }
        this.$_iniciarObserver();
      });
    },

    $_onEnterBusca(event) {
      if (event && event.target && typeof event.target.blur === 'function') {
        event.target.blur();
      }
      this.$_executarBusca(this.modoBusca);
    },

    $_isItemSelecionado(item) {
      const atual = this.valorAtual;
      if (!atual || !item) return false;
      if (atual === item) return true;

      if (this.campo === 'frota' || this.campo === 'placa') {
        const idItem = item.veiidveiculo || item.id;
        const idAtual = atual.veiidveiculo || atual.id;
        return (idItem && idAtual && idItem === idAtual)
          || (item.veifrota && atual.veifrota && item.veifrota === atual.veifrota)
          || (item.veiplaca && atual.veiplaca && item.veiplaca === atual.veiplaca);
      }
      if (this.campo === 'operador' || this.campo === 'executor' || this.campo === 'motorista' || this.campo === 'produtor') {
        const idItem = item.pesidpessoa || item.id;
        const idAtual = atual.pesidpessoa || atual.id;
        return (idItem && idAtual && idItem === idAtual)
          || (item.pescpf && atual.pescpf && item.pescpf === atual.pescpf)
          || (item.pesnome && atual.pesnome && item.pesnome === atual.pesnome);
      }
      if (this.campo === 'evento') {
        const idItem = item.evvideventoveiculo || item.id;
        const idAtual = atual.evvideventoveiculo || atual.id;
        const descItem = item.evvdescricao || item.descricao;
        const descAtual = atual.evvdescricao || atual.descricao || (typeof atual === 'string' ? atual : '');
        return (idItem && idAtual && idItem === idAtual)
          || (descItem && descAtual && descItem === descAtual);
      }
      if (this.campo === 'propriedade') {
        const idItem = item.proidpropriedade || item.id;
        const idAtual = atual.proidpropriedade || atual.id;
        return (idItem && idAtual && idItem === idAtual)
          || (item.pronome && atual.pronome && item.pronome === atual.pronome);
      }
      if (this.campo === 'atividade') {
        const idItem = item.veaidveiculoatividade || item.id || item.ataidatividadeabastecimento;
        const idAtual = atual.veaidveiculoatividade || atual.id || atual.ataidatividadeabastecimento;
        const descItem = item.veadescricao || item.atadescricao || item.descricao;
        const descAtual = atual.veadescricao || atual.atadescricao || atual.descricao || (typeof atual === 'string' ? atual : '');
        return (idItem && idAtual && idItem === idAtual)
          || (descItem && descAtual && descItem === descAtual);
      }
      if (this.campo === 'produto') {
        return (item.proidproduto && item.proidproduto === atual.proidproduto)
          || (item.prodescricao && item.prodescricao === (atual.prodescricao || atual.descricao || atual));
      }
      if (this.campo === 'talhao') {
        const idItem = item.talidtalhao || item.id;
        const idAtual = atual.talidtalhao || atual.id;
        return (idItem && idAtual && idItem === idAtual)
          || (item.talcodigo && atual.talcodigo && item.talcodigo === atual.talcodigo)
          || (item.taldescricao && atual.taldescricao && item.taldescricao === atual.taldescricao);
      }
      return false;
    },

    $_formatarFrotaTitulo(item) {
      if (!item) return '';
      const getVal = (val1, val2) => {
        if (val1 != null && String(val1).trim() !== '') {
          return String(val1).trim();
        }
        if (val2 != null && String(val2).trim() !== '') {
          return String(val2).trim();
        }
        return '-';
      };

      const frota = getVal(item.veifrota, item.frota);
      const placa = getVal(item.veiplaca, item.placa);
      const marca = getVal(item.veimarca, item.marca);

      if (frota === '-' && placa === '-' && marca === '-' && item.veidescricao) {
        return item.veidescricao;
      }
      return `${frota} - ${placa} - ${marca}`;
    },

    $_getItemTexto(item) {
      if (!item) return '';
      if (typeof item === 'string') return item;
      if (this.campo === 'frota') {
        return this.$_formatarFrotaTitulo(item);
      }
      return item[this.itemLabel] || item.evvdescricao || item.descricao || item.nome || '';
    },

    $_getItemSubtexto(item) {
      if (!item || typeof item !== 'object') return '';
      if (this.campo === 'frota') {
        const partes = [];
        if (item.veimarca) partes.push(item.veimarca);
        if (item.veitipo) partes.push(item.veitipo === 2 ? 'Maquinário (Horímetro)' : 'Veículo (Odômetro)');
        return partes.join(' • ');
      }
      if (this.campo === 'operador' || this.campo === 'executor') {
        const partes = [];
        if (item.pesnomefantasia) partes.push(item.pesnomefantasia);
        if (item.pescpf) partes.push(`CPF: ${item.pescpf}`);
        if (item.pestelefone) partes.push(`Tel: ${item.pestelefone}`);
        if (item.pesidpessoa || item.id) partes.push(`ID: ${item.pesidpessoa || item.id}`);
        return partes.join(' • ');
      }
      if (this.campo === 'evento') {
        const id = item.evvideventoveiculo || item.id;
        return id ? `Código Evento: ${id}` : '';
      }
      if (this.campo === 'propriedade') {
        const id = item.proidpropriedade || item.id;
        return id ? `Código / ID: ${id}` : '';
      }
      if (this.campo === 'atividade') {
        const id = item.veaidveiculoatividade || item.id || item.atacodigo;
        return id ? `Código / ID: ${id}` : '';
      }
      if (this.campo === 'produto') {
        const partes = [];
        if (item.proun) partes.push(`Unidade: ${item.proun}`);
        if (item.proprecoa) {
          const preco = typeof item.proprecoa === 'number' ? item.proprecoa : parseFloat(item.proprecoa);
          if (!Number.isNaN(preco)) {
            partes.push(new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(preco));
          }
        }
        return partes.join(' • ');
      }
      return '';
    },

    $_isEventoInativo(item) {
      if (!item) return false;
      const inativo = String(item.evvinativo ?? '').toUpperCase().trim();
      return inativo === 'S' || inativo === 'TRUE' || item.evvinativo === true || item.evvinativo === 1;
    },

    $_isAtividadeInativa(item) {
      if (!item) return false;
      const inativo = String(item.veainativo ?? '').toUpperCase().trim();
      return inativo === 'S' || inativo === 'TRUE' || item.veainativo === true || item.veainativo === 1;
    },
  },

  created() {
    this.campo = this.$route.query.campo
      || sessionStorage.getItem(APONTAMENTO_EMBARQUE_STORAGE.campoSelecao)
      || sessionStorage.getItem(MANUTENCAO_STORAGE.campoSelecao)
      || '';

    this.$_definirCriterioPadrao();

    try {
      if (this.campo === 'produto') {
        const novoItemSalvo = sessionStorage.getItem('MANUTENCAO_NOVO_ITEM');
        if (novoItemSalvo) {
          const itemObj = JSON.parse(novoItemSalvo);
          this.valorAtual = itemObj.produto || null;
        }
      }
      if (!this.valorAtual) {
        const formEmbarqueStr = sessionStorage.getItem(APONTAMENTO_EMBARQUE_STORAGE.formulario);
        if (formEmbarqueStr) {
          const formObj = JSON.parse(formEmbarqueStr);
          this.valorAtual = formObj[this.campo] || null;
        }
      }
      if (!this.valorAtual) {
        const formManutencaoStr = sessionStorage.getItem(MANUTENCAO_STORAGE.formulario);
        if (formManutencaoStr) {
          const formObj = JSON.parse(formManutencaoStr);
          this.valorAtual = formObj[this.campo] || null;
        }
      }
    } catch (e) {
      console.warn('Erro ao ler valor atual da seleção:', e);
    }

    this.$_findDb();
  },

  beforeDestroy() {
    this.$_desvincularScrollListener();
    this.$_destruirObserver();
  },
};
</script>

<style scoped>
.center-selecao {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.bg-search-container {
  background-color: #ffffff;
  flex-shrink: 0;
}

.lista-selecao-scroll {
  flex: 1;
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 32px;
}

.lista-selecao-scroll ::v-deep .simplebar-scrollbar::before {
  background: rgba(76, 175, 80, 0.5) !important;
}

.lista-selecao-scroll ::v-deep .simplebar-track.simplebar-vertical {
  width: 8px;
}

.item-selecao-card {
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
}

.item-selecao-card:hover {
  border-color: #4caf50;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.15);
}

.item-selecionado {
  border-color: #4caf50 !important;
  background-color: #f1f8e9 !important;
}

.text-wrap-container {
  min-width: 0;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

.item-titulo {
  line-height: 1.35;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.item-subtitulo {
  line-height: 1.3;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.sentinela-scroll {
  width: 100%;
  min-height: 48px;
}

.cursor-pointer {
  cursor: pointer;
}

.toggle-filtro-frota {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
}

.btn-filtro-frota {
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 0.82rem !important;
  letter-spacing: 0.2px;
}

.toggle-filtro-frota .v-btn.v-btn--active {
  background-color: #2e7d32 !important;
  color: #ffffff !important;
}

.toggle-filtro-frota .v-btn.v-btn--active .v-icon {
  color: #ffffff !important;
}

.radio-group-busca {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.radio-group-busca ::v-deep .v-input__slot {
  margin-bottom: 0 !important;
}

.radio-group-busca ::v-deep .v-radio {
  margin-right: 14px !important;
  margin-bottom: 2px !important;
}

.radio-group-busca ::v-deep .v-label {
  font-size: 0.88rem !important;
  color: #2c3e50 !important;
  font-weight: 500;
}

.radio-group-busca ::v-deep .v-icon {
  font-size: 20px !important;
}

.campo-busca-input ::v-deep .v-input__control {
  min-height: 40px !important;
}

.campo-busca-input ::v-deep input {
  font-size: 0.92rem;
}

.btn-busca-acao {
  background-color: #4CAF50 !important;
  color: #ffffff !important;
  min-width: 44px !important;
  height: 40px !important;
  padding: 0 10px !important;
  border-radius: 4px !important;
  transition: all 0.2s ease;
}

.btn-busca-acao:hover {
  background-color: #4CAF50 !important;
}

.btn-busca-acao.btn-busca-ativo {
  background-color: #4CAF50 !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.25) !important;
}
</style>
